export interface IItinerary {
  departureAirport: string;
  arrivalAirport: string;
  departureDate: string;
}

export enum DateFormat {
  YMD = 'YYYYMMDD',
  DotYMD = 'YYYY.MM.DD.',
  DotYMDd = 'YYYY.MM.DD.dd',
  DotYMD_d = 'YYYY.MM.DD. dd',
  DotMDd = 'MM.DD.dd',
  DotMD_d = 'MM.DD. dd',
  YMDHm = 'YYYYMMDDHHmm',
}

export interface IKeyStringValue {
  [key: string]: string;
}

export interface IKeyAnyValue {
  [key: string]: any;
}

export const DurationMap = new Map<string, string>([
  ['5D', '5일'],
  ['7D', '7일'],
  ['14D', '14일'],
  ['20D', '20일'],
  ['30D', '1개월'],
  ['60D', '2개월'],
  ['90D', '3개월'],
  ['180D', '6개월'],
  ['365D', '1년'],
]);

export const MEMBER_FARE_CUT_LINE: number = 2;
